/**
 * @generated SignedSource<<df3cb280c6320e77baf5918c8eb4eca8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletCounterpartyPanel_Query$variables = {
  counterparty?: string | null | undefined;
  month?: string | null | undefined;
  slug: string;
  year?: number | null | undefined;
};
export type walletCounterpartyPanel_Query$data = {
  readonly walletCounterpartyLines: ReadonlyArray<{
    readonly amount: number;
    readonly counterparty: string;
    readonly currency: string | null | undefined;
    readonly date: string | null | undefined;
    readonly memo: string | null | undefined;
  }>;
};
export type walletCounterpartyPanel_Query = {
  response: walletCounterpartyPanel_Query$data;
  variables: walletCounterpartyPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "counterparty"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "counterparty",
        "variableName": "counterparty"
      },
      {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
      },
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      },
      {
        "kind": "Variable",
        "name": "year",
        "variableName": "year"
      }
    ],
    "concreteType": "WalletCounterpartyLine",
    "kind": "LinkedField",
    "name": "walletCounterpartyLines",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "counterparty",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "memo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "walletCounterpartyPanel_Query",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "walletCounterpartyPanel_Query",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "41d81057ccf638a766587533094ae7f7",
    "id": null,
    "metadata": {},
    "name": "walletCounterpartyPanel_Query",
    "operationKind": "query",
    "text": "query walletCounterpartyPanel_Query(\n  $slug: String!\n  $counterparty: String\n  $month: String\n  $year: Int\n) {\n  walletCounterpartyLines(slug: $slug, counterparty: $counterparty, month: $month, year: $year) {\n    date\n    counterparty\n    memo\n    currency\n    amount\n  }\n}\n"
  }
};
})();

(node as any).hash = "764b867fd4cc4c0a591f0dd9f7cb9be7";

export default node;
